import { DEFAULT_JACKPOT_CODE } from '../../../constants';
import { getProviderJackpotIdentifier } from '../../../utils';
import { useGamesStore } from '../../store';

export const useJackpot = (
  providerServiceId: string,
  code: string = DEFAULT_JACKPOT_CODE
) => {
  const jackpotIdentifier = getProviderJackpotIdentifier(
    providerServiceId,
    code
  );

  return useGamesStore((store) => store.jackpots[jackpotIdentifier]?.levels);
};
